export const graphFormat = text => {
  const lastSpace = text.lastIndexOf(' ')
  const begin = text.substring(0, lastSpace)
  const end = text.substring(lastSpace + 1, text.length)
  return begin + '\u00A0' + end
}

export const formatData = data => {
  data.landing_page.desc = graphFormat(data.landing_page.desc)
  data.times = data.times.map(time => {
    time.body = graphFormat(time.body)
    return time
  })
  Object.keys(data.narratives).forEach(narKey => {
    data.narratives[narKey].body = graphFormat(data.narratives[narKey].body)
  })
  Object.keys(data.industries).forEach(indKey => {
    data.industries[indKey].desc = graphFormat(data.industries[indKey].desc)
  })
  return data
}
